import type { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { FireAndFlowerDefaultCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/custom-cards-2x2/fire-and-flower-default-card-stack-background/fire-and-flower-default-card-stack-background.component';
import { FireAndFlowerDefaultCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/custom-cards-2x2/fire-and-flower-default-card-stack-content/fire-and-flower-default-card-stack-content.component';
import { FireAndFlowerOldStyleCardStack } from './fire-and-flower-old-style-card-stack';

export class FireAndFlowerDefaultCardStack extends FireAndFlowerOldStyleCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    return FireAndFlowerDefaultCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return FireAndFlowerDefaultCardStackContentComponent;
  }
}
